// extracted by mini-css-extract-plugin
export default {"warningBorder":"o5duJm0ifkOvTnYVkk_d","alertBorder":"nFGRHcoTL_zEGHYo06Uc"};